<template>
  <div
    v-show="open"
    class="z-50 fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
  >
    <div v-show="open" class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <div
      class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full"
      :class="maxWidthClass"
    >
      <div class="absolute top-0 right-0 pt-4 pr-4">
        <button
          @click="close"
          type="button"
          class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
        >
          <svg
            class="h-6 w-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
      <div>
        <div class="text-center">
          <h3
            class="text-left text-xl leading-6 font-medium text-gray-900 pb-5 bg-gray-50 px-6 py-4"
          >
            <slot name="header"></slot>
          </h3>
          <slot name="body"></slot>
        </div>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            default: false
        },
        maxWidthClass: {
            type: String,
            default: "sm:max-w-3xl"
        }
    },
    methods: {
        close() {
            this.$emit("close");
        }
    }
};
</script>
